import { httpRequest } from "@/utils/HttpRequest";
import { ISearchPage, IPage } from "@/types/ScmTypes";

export interface ITransferDataMonitorDetail {
    id: string, // string
    beginNum?: string,   // 2
    bookOccupyNum?: string,   // null
    busSaleNum?: string,   // null
    busSreturnNum?: string,   // null
    compensateNum?: string,   // null
    currentNum?: string,   // 2
    differenceNum?: string,   // 0
    maintainNum?: string,   // null
    maintainOccupyNum?: string,   // null
    materialCode?: string,   // "612600060133"
    materialName?: string,   // "外置节温器"
    mreturnNum?: string,   // null
    occupyDifference?: string,   // 0
    occupyNum?: string,   // 0
    preturnNum?: string,   // 0
    preturnOccupyNum?: string,   // 0
    purchasePrice?: string,   // 85
    purchasePriceLatest?: string,   // 85
    purhcaseNum?: string,   // 2
    remainNum?: string,   // 2
    saleNum?: string,   // 0
    saleOccupyNum?: string,   // 0
    shopId?: string,   // "64eec0c1d6f37078b6b460e4cb0ac9d7"
    sreturnNum?: string,   // 0
    stockCost?: string,   // 170
    stockCostLatest?: string,   // 170
    unusualSreturnNum?: string,   // 0
    [key: string]: any
}

//搜索条件
export interface ITransferDataMonitorSearchFields {
    [key: string]: any
}

export interface ITransferDataMonitorSearch
    extends ITransferDataMonitorSearchFields, ISearchPage {

}
export interface IStatistics {
    num: number;// 差异数量
    amount: number;// 差异金额
    costAmount: number;// 差异金额
    profit: number;// 差异毛利
}




//进销存报表
class TransferDataMonitorService {
    async page(searchVo: ITransferDataMonitorSearch) {
        // const apiUrl = "/hd-sms/transfer/to/statistics";
        const apiUrl = "/zzw-vrm/transfer/to/statistics";
        return await httpRequest.post<IPage<ITransferDataMonitorDetail>>(apiUrl, searchVo);
    }
    async export(searchVo: ITransferDataMonitorSearch) {
        // const apiUrl = "/hd-sms/transfer/to/statistics/export";
        const apiUrl = "/zzw-vrm/transfer/to/statistics/export";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: 300000 });
    }
    // 头部统计
    async statistics(searchVo: ITransferDataMonitorSearch) {
        // const apiUrl = "/hd-sms/transfer/to/top/statistics";
        const apiUrl = "/zzw-vrm/transfer/to/top/statistics";
        return await httpRequest.post<IStatistics>(apiUrl, searchVo);
    }

}

export const transferDataMonitorService = new TransferDataMonitorService();